/**
 * Espace entreprise (agro-entreprise-page), adresse qui se termine par /admin.
 *
 * Toujours absolue : une valeur saisie sans https:// (variable de CI « entreprise.assiganto-agro.com/admin »)
 * serait lue par le navigateur comme un chemin du site courant, et mènerait à une page blanche
 * (togo.assiganto-agro.com/entreprise.assiganto-agro.com/admin/...).
 */
export const absoluteUrl = (value) => {
    const url = (value || "").trim().replace(/\/+$/, "");
    return !url || /^https?:\/\//i.test(url) ? url : `https://${url}`;
};

export const ENTREPRISE_ADMIN_URL =
    absoluteUrl(process.env.REACT_APP_PRODUCTION_PAGE) || "https://entreprise.assiganto-agro.com/admin";
